import Phaser from "phaser";
import { socket, socketConnected } from "../../../../utils/nakama";
import { matchIdGame } from "../../Game.jsx";
import opCodes from "../../../../constants/opCodes.jsx";
export class Card {
    constructor(texture, scale, bubbleTexture, isResurrected = false, isAnimated, startX=0, startY=0) {
        this.texture = texture;
        this.scale = scale;
        this.bubbleTexture = bubbleTexture;
        this.isResurrected = isResurrected;
        this.isAnimated = isAnimated; //tracks if this is the most recent card and therefore should be animated
        //starting coordinates for the animation 
        this.startX = startX;
        this.startY = startY;
    }
}

export default class CardGameObject extends Phaser.GameObjects.Sprite {

    constructor(scene, x, y, card) { //card is a Card object
        super(scene, x, y, 'card_images', card.texture);
        this.scale = card.scale;
        this.bubbleDisplacement = {x: 63.5*card.scale, y: -148*card.scale};
        this.updateBubbleTexture(card.bubbleTexture);
        // if (card.texture !== "CardBack"){
        //     this.handleSteal(card);
        // }
        this.updateResurrectBanner(card.isResurrected);
        this.animateHouseCard(card.isAnimated, card.stealIndex, card.startX, card.startY);
    }

    animateHouseCard(isAnimated, stealIndex, startX, startY) {
        // console.log("this: ", isAnimated)
        if (isAnimated && isAnimated !== undefined && stealIndex !== -1) {
            this.scene.tweens.add({
                targets: this,
                scale: 0.90, // Final x position
                duration: 300, // Duration of the tween in milliseconds
                x: {from: startX, to: this.x},
                y: {from: startY === 0 ? this.y : startY, to: this.y},
                ease: 'Power2', // Easing function
                rotation: 6.35,
                loop: 0, // Infinite loop
            });
            // console.log("new tween: ", tween);
        }
    }

    updateBubbleTexture(bubbleTexture) {
        if (this.bubbleTexture) {
            this.bubbleTexture.destroy(); //remove previous bubble
        }
        if (bubbleTexture) {
            this.bubbleTexture = this.scene.add.image(this.x + this.bubbleDisplacement.x, this.y + this.bubbleDisplacement.y, 'all_images', bubbleTexture).setScale(this.scale * 1.35).setDepth(this.depth + 1);
        }
    }

    updateResurrectBanner(show) {
        if (show) {
            this.resurrectedBanner = this.scene.add.image(this.x, this.y + (179*this.scale), 'all_images', 'resurrected_banner').setScale(this.scale);
            this.resurrectedText = this.scene.add.text(this.x, this.y + (179*this.scale), "RESURRECTED", { fontSize: 37.6*this.scale + "px", fontFamily: "TruculentaBold", fill: '#FFFFFF', align: 'center' }).setOrigin(0.5, 0.5);
        }
        else if (this.resurrectedBanner) {
            this.resurrectedBanner.destroy();
            this.resurrectedText.destroy();
        }
    }

    handleDrag(x, y) {
        this.x = x;
        this.y = y;
        if (this.bubbleTexture) {
            this.bubbleTexture.x = x + this.bubbleDisplacement.x;
            this.bubbleTexture.y = y + this.bubbleDisplacement.y;
        }
    }

    // handleSteal = async (card) => {
    //     if (this.index !== undefined && this.index !== null) {
    //         this.on("pointerdown", async () => {
    //             if (socketConnected && matchIdGame !== "" && this.scene.stealSelected.value && !this.scene.stealSelected.isResurrect){ //play steal power card
    //                 let data = {
    //                     "name": "steal",
    //                     "option": this.index
    //                 }
    //                 this.scene.setStealSelected(false);
    //                 try {
    //                     console.log("steal power card play request");
    //                     await socket.sendMatchState(matchIdGame, opCodes.playerPlayPowerCard, JSON.stringify(data));
    //                     this.scene.setStealSelected(false);
    //                 } catch (err) {
    //                     console.log("Error playing power card: ", err);
    //                 }
    //             }
    //             else if (socketConnected && matchIdGame !== "" && this.scene.stealSelected.value && this.scene.stealSelected.isResurrect && this.scene.stealSelected.resurrectIndex !== -1) { //resurrected steal card
    //                 let data = {
    //                     "name": "resurrect",
    //                     "option": {
    //                         resurrectIndex: this.scene.stealSelected.resurrectIndex,
    //                         resurrectOption: this.index
    //                     }
    //                 }
    //                 this.scene.setStealSelected(false);
    //                 try {
    //                     console.log("steal resurrect power card play request");
    //                     await socket.sendMatchState(matchIdGame, opCodes.playerPlayPowerCard, JSON.stringify(data));
    //                     this.scene.setStealSelected(false);
    //                 } catch (err) {
    //                     console.log("Error resurrecting steal power card: ", err);
    //                 }
    //             }
    //         })                                
    //         this.setInteractive();    
    //     }
        
    // }
}

// Register a function to the gameobjectfactory, allowing you to use this.add.<objectname>
Phaser.GameObjects.GameObjectFactory.register("card", function (x, y, card) {
    const cardInst = new CardGameObject(this.scene, x, y, card);

    this.displayList.add(cardInst);
    this.updateList.add(cardInst);

    return cardInst;
})